import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { IAppState } from './appState';
import { AnzahlTiereEnum, initialAnzahlMehrereHunde } from './reducers/versicherungsnehmer.reducer';
import { initialeHunderassenAuswahlElemente } from './initialHunderassenAuswahlElemente';

export const INITIAL_STATE: IAppState = {
  produkt: null,
  version: 11,
  rabattstufe: 0,
  antragsnummer: null,
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  transientState: {
    zurueckZumShopModalOpen: false,
    priceGuarantee: false,
    fehlerCodeTaas: '',
    tarifierungIsInProgress: false,
    role: null,
    vorvertragVorschaeden: null,
    featureToggles: {},
    regexps: {},
    kooperationen: null,
  },
  vorbelegungen: {
    versicherungsnehmerVorbelegt: false,
    adresseImmobilieVorbelegt: false,
  },
  risikoort: {
    plz: '',
    ort: '',
    strasse: '',
    hausnummer: '',
  },
  adressvorschlag: {
    orte: [],
    strassen: [],
    lastError: null,
  },
  versicherungsnehmer: {
    geburtsdatum: null,
    familienstand: null,
    isAssekuranztarif: false,
    anzahlTiere: AnzahlTiereEnum.EINES,
    tiere: [],
    rasseEinHund: null,
    hunderassenAuswahlElemente: initialeHunderassenAuswahlElemente,
    anzahlMehrereHunde: initialAnzahlMehrereHunde,
    rasseMehrereHunde: new Array(initialAnzahlMehrereHunde),
  },
  vorschaeden: {
    vorhanden: null,
    thhHundVorschaeden: 0,
  },
  vertragsoptionen: {
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0000,
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: true,
    isWeitererVertrag: false,
  },
  gesamtbeitrag: 0,
  jahresbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
};
